import { Route, Routes } from "react-router-dom";
import Home from "../../pages/web/Home";
import Cart from "../../pages/web/Cart";
import Wishlist from "../../pages/web/Wishlist";
import Checkout from "../../pages/web/Checkout";
import Login from "../../pages/web/auth/Login";
import SignUp from "../../pages/web/auth/SignUp";
import Product from "../../pages/web/Product";
import PrivacyPolicy from "../../pages/web/PrivacyPolicy";
import TermCondition from "../../pages/web/TermCondition";
import ReturnPolicy from "../../pages/web/ReturnPolicy";
import ShippingPolicy from "../../pages/web/ShippingPolicy";
import About from "../../pages/web/About";
import Contact from "../../pages/web/Contact";
import Dashboard from "../../pages/user/Dashboard";
import Order from "../../pages/user/Order";
import MyAccount from "../../pages/web/MyAccount";
import Profile from "../../pages/user/Profile";
import ProductList from "../../pages/web/ProductList";
import Products from "../../pages/user/Products";
import OrderDetails from "../../pages/user/OrderDeatils";
import MoboEatHomePage from "../../pages/web/Home1";
import ForgotPassword from "../../pages/web/auth/ForgotPassword";
import VendorManager from "../../pages/web/VendorManager";
import DeleteAccount from "../../pages/web/auth/DeleteAccount";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MoboEatHomePage />} />
      <Route path="/user" element={<Home />} />
      <Route path="/get-products" element={<ProductList />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/products/:id" element={<Products />} />
      <Route path="/wishlist" element={<Wishlist />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/signup" element={<SignUp />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/terms-condition" element={<TermCondition />} />
      <Route path="/return-policy" element={<ReturnPolicy />} />
      <Route path="/shipping-policy" element={<ShippingPolicy />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/product/:id/:slug" element={<Product />} />

      {/* User Routes */}
      <Route path="/user/dashboard" element={<Dashboard />} />
      <Route path="/user/vednor-manager/:id" element={<VendorManager />} />
      <Route path="/user/profile" element={<Profile />} />
      <Route path="/user/orders" element={<Order />} />
      <Route path="/user/order-details/:id" element={<OrderDetails />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Main User Routes */}
      <Route path="/my-account" element={<MyAccount />} />

    </Routes>
  );
};
export default AppRoutes;
